import ApiService from '@/shared/services/api.service';
const LS_ATLAS_LAYERS_KEY = 'st_atlas_layers';
const LS_ATLAS_SIDEBAR = 'st_atlas_sidebar';
const LS_ATLAS_CONTAINERS_KEY = 'st_atlas_containers';
const LS_ATLAS_PARCEL_KEY = 'st_atlas_parcel';
const LS_ATLAS_ACTIVE_CITIZEN_FEATURES_KEY = 'atlas_active_citizen_features';
const LS_ATLAS_PANEL_WIDTH_KEY = 'st_atlas_panel';
import KTCookie from '@/assets/js/components/cookie.js';

export class AtlasService {

    static getLayers(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/layers/me', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getPublicSystemLayers(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/public-layers/', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getSystemLayers(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/layers/me', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getPublicLayers(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/public-layers/', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getArcgisApps(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/arcgis-apps/me', params)
                .then((response) => resolve(response.data?.data))
                .catch((error) => reject(error));
        });
    }

    static getSimpleLayers(params = {}) {
        return new Promise((resolve, reject) => {
            ApiService.query( '/layers-simple/me', params)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getSimpleLayer(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/layers-simple/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static createLayer(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/layer-creation-requests/', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }
    static createLayerById(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/layer-creation-requests/arcgis-import-by-id', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static publishLayer(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/layer-creation-requests/publish-layer', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static compareLayers(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/layer-creation-requests/publish-layer/compare-sublayers', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static updateLayer(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layer-creation-requests/${id}`, { ...data })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

     static addLayerIntoContainer(data) {
        return new Promise((resolve, reject) => {
            ApiService.post( '/layer-creation-requests/component', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static updateLayerIntoContainer(id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layer-creation-requests/component/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateLayerFromContainer(id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layers-simple/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateLayerContainer(id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layers/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static addArcgisApp(payload) {
        return new Promise((resolve, reject) => {
            ApiService.post("/arcgis-apps/?echo=true", { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateArcgisApp(id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/arcgis-apps/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteLayer(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/layers/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteSimpleLayer(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/layers-simple/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteArcgisApp(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/arcgis-apps/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static upload(token, files) {
        return new Promise((resolve, reject) => {
           ApiService.post('/files?echo=true', files, {
               'content-type': 'multipart/form-data',
               'x-file-access-token': token,
           })
               .then((response) => resolve(response.data))
               .catch((error) => reject(error));
        });
    }

    static generateToken() {
        return new Promise((resolve, reject) => {
            ApiService.post( '/generate-token', { ...data } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static getLayerCreationStatus(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/layer-creation-requests/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getGisToken(isStaff) {
        const path = isStaff ? '/gis-tokens/get-token' : '/public-gis-tokens/guest-token';
        return new Promise((resolve, reject) => {
            ApiService.get(path)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static addArea(payload) {
        return new Promise((resolve, reject) => {
            ApiService.post('/interest-areas/?echo=true', { ...payload } )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        })
    }

    static deleteArea(area) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/interest-areas/${area.id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateArea( data) {
        const { payload, id } = data;
        return new Promise((resolve, reject) => {
            ApiService.patch(`/interest-areas/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getAreas() {
         return new Promise((resolve, reject) => {
            ApiService.get('/interest-areas/')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getLayerPresets() {
        return new Promise((resolve, reject) => {
            ApiService.get('/layer-visibility-presets/')
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static createLayerPreset(payload) {
        return new Promise((resolve, reject) => {
            ApiService.post('/layer-visibility-presets/?echo=true', { ...payload })
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static deleteLayerPreset(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/layer-visibility-presets/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static patchLayerPreset(id, payload) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layer-visibility-presets/${id}`, { ...payload })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getPredefinedLayerPresets(ownerOrgId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/predefined-layer-visibility-presets/?owner_org_id=${ownerOrgId}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getPredefinedLayerPreset(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/predefined-layer-visibility-presets/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static createPredefinedLayerPreset(payload) {
        return new Promise((resolve, reject) => {
            ApiService.post('/predefined-layer-visibility-presets/manage?echo=true', { ...payload })
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static deletePredefinedLayerPreset(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/predefined-layer-visibility-presets/manage/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getUrbanismRegulations(key) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/urbanism-regulations?query=zone_key like ${key}`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(error));
        });
    }

    static getPublicUrbanismRegulations(key) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/urbanism-regulations/public?zone_key=${key}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateSublayer(data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/${data.endpointByLayerType}/${data.layerId}/sublayers/${data.gis_id}`, { ...data })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getPersistedLayers() {
        const layersString = window.localStorage.getItem(LS_ATLAS_LAYERS_KEY);
        return layersString ? JSON.parse(layersString) : {};
    }

    static persistLayers(layers) {
        const layersString = JSON.stringify(layers);
        window.localStorage.setItem(LS_ATLAS_LAYERS_KEY, layersString);
    }

    static getPersistedSidebarState() {
        const state =  window.localStorage.getItem(LS_ATLAS_SIDEBAR);
        return state === 'true';
    }

    static persistSidebarState(state) {
        window.localStorage.setItem(LS_ATLAS_SIDEBAR, state);
    }

    static getPersistedContainers() {
        const openContainers = window.localStorage.getItem(LS_ATLAS_CONTAINERS_KEY);
        return openContainers ? JSON.parse(openContainers) : [];
    }

    static persistedContainersKeyDefined() {
        return Object.keys(window.localStorage).find((key) => key === LS_ATLAS_CONTAINERS_KEY)
    }

    static persistContainers(layers) {
        const openContainers = JSON.stringify(layers);
        window.localStorage.setItem(LS_ATLAS_CONTAINERS_KEY, openContainers);
    }

    static getPersistedParcel() {
        const parcelString = window.localStorage.getItem(LS_ATLAS_PARCEL_KEY);
        return parcelString ? JSON.parse(parcelString) : {};
    }
    static destroyPersistedParcel() {
        window.localStorage.removeItem(LS_ATLAS_PARCEL_KEY);
    }

    static getPersistedActiveCitizenFeatures() {
        const saved = window.localStorage.getItem(LS_ATLAS_ACTIVE_CITIZEN_FEATURES_KEY);
        return saved ? JSON.parse(saved) : [];
    }

    static persistActiveCitizenFeatures(ids) {
        window.localStorage.setItem(LS_ATLAS_ACTIVE_CITIZEN_FEATURES_KEY, JSON.stringify(ids));
    }

    static getPersistedPanelWidth(name, userId, defaultWidth) {
        const raw = window.localStorage.getItem(`${LS_ATLAS_PANEL_WIDTH_KEY}_${name}_${userId}`);
        if (!raw) return defaultWidth;
        const parsed = parseInt(raw, 10);
        return isNaN(parsed) ? defaultWidth : parsed;
    }

    static persistPanelWidth(name, userId, width) {
        window.localStorage.setItem(`${LS_ATLAS_PANEL_WIDTH_KEY}_${name}_${userId}`, width);
    }

    static reSyncSimpleLayers(id) {
        return new Promise((resolve, reject) => {
            ApiService.post( `/layers-simple/${id}/arcgis-resync` )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }
    static reSyncLayers(id) {
        return new Promise((resolve, reject) => {
            ApiService.post( `/layers/${id}/arcgis-resync` )
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }
    static getLayerPopupInfo(id, gisToken) {
        return new Promise((resolve, reject) => {
            let reqUrl = `/layers/${id}/service-item-data`;
            if(gisToken) {
                reqUrl += `?gis_token=${gisToken}`
            }
            ApiService.get(reqUrl)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
    static getSimpleLayerPopupInfo(id, gisToken) {
        return new Promise((resolve, reject) => {
            let reqUrl = `/layers-simple/${id}/service-item-data`;
            if(gisToken) {
                reqUrl += `?gis_token=${gisToken}`
            }
            ApiService.get(reqUrl)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
    static getAsideToggleState() {
         return KTCookie.getCookie('kt_aside_toggle_state')
    }
    static setAsideToggleState(state) {
         KTCookie.setCookie('kt_aside_toggle_state', state);
    }

    static getUrbanismRegulationZone(key) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/urbanism-regulation-zones?query=key like ${key}`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(error));
        });
    }

    static getPublicUrbanismRegulationZone(key) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/urbanism-regulation-zones-public?query=key like ${key}`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(error));
        });
    }

    static extractIntersectionDataToFile(data) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/layers/extract-data`, data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getLayerComments(parentId, extent) {
        let reqUrl = "/layer-comments/?";

        if (extent) {
            const extentReq = `${extent.xmin},${extent.ymin},${extent.xmax},${extent.ymax}`
            reqUrl = `${reqUrl}extent=${extentReq}&`
        }

        // TODO: at some point 100 will not be enough
        reqUrl = parentId ?
            `${reqUrl}query=parent_id eq ${parentId}&limit=100` :
            `${reqUrl}limit=100`;
        return new Promise((resolve, reject) => {
            ApiService.get(`${reqUrl}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static addLayerComment(data) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/layer-comments/?echo=true`, data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static patchLayerComment(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layer-comments/${id}?echo=true`, data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteLayerComments(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/layer-comments/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getFeatureComments(layer_id, sublayer_id, feature_id, page = 0, limit = 5) {
        return new Promise((resolve, reject) => {
            const query = `layer_id eq ${layer_id} and sublayer_id eq ${sublayer_id} and feature_id eq ${feature_id}`;
            const skip = page * limit;
            ApiService.query('/layer-comments/', { 
                params: { 
                    query,
                    skip,
                    limit,
                    sort: '-created_date',  // Most recent first
                    envelope: true,         // Include pagination metadata
                    pagination: true,       // Request pagination info
                } 
            })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static addFeatureComment(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/layer-comments/?echo=true', data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteFeatureComment(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/layer-comments/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static updateFeatureComment(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/layer-comments/${id}?echo=true`, data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getAllFeatureComments(filterParams = {}) {
        return new Promise((resolve, reject) => {
            // Strip the id_ prefix from composite layer_id value before building query
            let processedQuery = filterParams.query || '';
            if (processedQuery.includes('layer_id eq')) {
                processedQuery = processedQuery.replace(
                    /layer_id eq '([^']+)'/g,
                    (match, value) => {
                        const gisLayerId = value.substring(value.indexOf('_') + 1);
                        return `layer_id eq '${gisLayerId}'`;
                    }
                );
            }

            // Translate flat filter key to nested MongoDB path
            if (processedQuery.includes('application_request_number')) {
                processedQuery = processedQuery.replace(/application_request_number/g, 'application.request_number');
            }

            // hackis way to filter out old trash until we delete them from db
            let query = 'feature_id ge 0';
            if (processedQuery) {
                query += ` and ${processedQuery}`;
            }

            ApiService.query('/layer-comments/', {
                params: {
                    ...filterParams,
                    query,
                    sort: filterParams.sort || '-created_date',
                },
            })
            .then((response) => resolve(response))
            .catch((error) => reject(error));
        });
    }

    // --- Citizen Features ---

    static getCitizenFeatures(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/citizen-features/', params)
                .then((response) => {
                    const features = response.data?.data || response.data || [];
                    resolve(features);
                })
                .catch((error) => reject(error));
        });
    }

    static getCitizenFeature(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/citizen-features/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getCitizenFeatureStatus(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/citizen-features/${id}/status`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static createCitizenFeature(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/citizen-features/', data, {}, true)
                .then((response) => resolve(response))
                .catch((error) => reject(error));
        });
    }

    static updateCitizenFeature(id, data) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/citizen-features/${id}`, data)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static deleteCitizenFeature(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/citizen-features/${id}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    static getTeamCitizenFeatures(params) {
        return new Promise((resolve, reject) => {
            ApiService.query('/citizen-features/team', params)
                .then((response) => {
                    const features = response.data?.data || response.data || [];
                    resolve(features);
                })
                .catch((error) => reject(error));
        });
    }

    static getTeamMembers() {
        return new Promise((resolve, reject) => {
            ApiService.query('team-users', {
                params: {
                    fields: 'user_id,user_name,first_name,last_name',
                    limit: 100,
                },
            })
                .then((response) => {
                    const members = response.data?.data || response.data || [];
                    resolve(members);
                })
                .catch((error) => reject(error));
        });
    }
}
